
export default[
    {
        show(row,extra){
            return row.shbj==='1'
        },
        tag:'my-btn',
        type:'detail',
        text:'详情',
        click(row,extra){
            this.goto({
                path: '/bidding/project/detail',
                query: {
                    id: row.procode,
                }
            });
        }
    },{
        show(row,extra){
            return row.shbj!=='1'
        },
        tag:'my-btn',
        type:'del',
        text:'删除',
        click(row,extra){
            this.$post(`${this.getGetters('mngUrl')}/Zbdl/Project/del.json`,{
                id:row.procode,
                oper:'del'
            }, (data, res) => {
                ShowMsg('删除成功','success')
                this.$emit('reload')
            });
        }
    },{
        show(row,extra){
            return row.shbj!=='1'
        },
        tag:'my-btn',
        type:'edit',
        text:'修改',
        click(row,extra){
            var that = this
            that.$get(`${that.getGetters('mngUrl')}/Zbdl/Project/edit.json`,{
                id:row.procode,
            }, (data, res) => {
                var url = ''
                if(data['page-url']==='normal'){
                    url = 'form'
                }else if(data['page-url']==='zxsp'){
                    url = 'getproinfoForm'
                }else if(data['page-url']==='sjjt'){
                    url = 'getsjjtForm'
                }
                
                that.goto({
                    path: '/bidding/project/'+url,
                    query: {
                        id: row.procode,
                    }
                });
            });
            
            
        }
    },
    
]